export const enum API_CODE {
  SSO_TOKEN_TEMP_EXIST_ERROR_CODE = '100012',

  /**
   * 此登入暫存資訊目前不存在。
   */
  SSO_TOKEN_TEMP_NOT_EXIST_ERROR_CODE = '100013',

  /**
   * 此 user 內勤角色不存在。
   */
  USER_ROLE_JOB_TYPE_OFFICE_NOT_EXIST_ERROR_CODE = '100015',

  /**
   * 指定招攬人無法登入前台
   */
  SPECIFIC_RECRUITMENT_PERSON_CANNOT_LOGIN_FRONTEND = '100019',
}
